import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { TimeseriesDataPoint } from '../../../../domain/models/timeseries.model';

@Component({
  selector: 'lib-timeseries-data-table',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './timeseries-data-table.component.html',
  styleUrl: './timeseries-data-table.component.scss',
})
export class TimeseriesDataTableComponent {
  readonly dataPoints = input.required<TimeseriesDataPoint[]>();
  readonly focusedRow = signal(-1);

  focusRow(index: number): void {
    this.focusedRow.set(index);
  }

  onGridKeydown(event: KeyboardEvent): void {
    const len = this.dataPoints().length;
    if (!len) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.focusedRow.set(Math.min(this.focusedRow() + 1, len - 1));
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.focusedRow.set(Math.max(this.focusedRow() - 1, 0));
        break;
      case 'Home':
        event.preventDefault();
        this.focusedRow.set(0);
        break;
      case 'End':
        event.preventDefault();
        this.focusedRow.set(len - 1);
        break;
    }
  }

  formatTimestamp(ts: string): string {
    return new Date(ts).toLocaleString();
  }

  formatValue(value: number | string | null): string {
    if (value === null) return '—';
    if (typeof value === 'string') return value;
    return value.toLocaleString(undefined, { maximumFractionDigits: 4 });
  }
}
